import { render, staticRenderFns } from "./CasesListClient.vue?vue&type=template&id=0d419cbd&scoped=true&"
import script from "./CasesListClient.vue?vue&type=script&lang=js&"
export * from "./CasesListClient.vue?vue&type=script&lang=js&"
import style0 from "./CasesListClient.vue?vue&type=style&index=0&id=0d419cbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d419cbd",
  null
  
)

export default component.exports